import { getAuthAxiosBackend } from "@/helpers/axios"

class EducationCurrentDataServices{

    get(id){
        return getAuthAxiosBackend().get('EducationCurrentData/getEducationCurrentData/' + id.toString())
    }

    getByPersonId(personId){
        return getAuthAxiosBackend().get('EducationCurrentData/getEducationCurrentDataByPersonId/' + personId)
    }

    getAll(data = {}){
        return getAuthAxiosBackend().get('EducationCurrentData/all', {params: data})
    }

    add(data){
        return getAuthAxiosBackend().post('EducationCurrentData/addEducationCurrentData', data)
    }

    edit(id, data){
        return getAuthAxiosBackend().put('EducationCurrentData/updateEducationCurrentData/' + id, data)
    }

    delete(id){
        return getAuthAxiosBackend().delete('EducationCurrentData/softDeleteEducationCurrentData/' + id.toString())
    }
}

export default new EducationCurrentDataServices()